<template>
  <div>
    <b-modal
      hide-footer
      hide-backdrop
      no-close-on-esc
      header-class="employeeDetails__header_class"
      modal-class="employeeDetails__modal_class"
      title-class="employeeDetails__title_class"
      title="Employee Details"
      :ref="refId"
      :id="refId"
      centered
      no-fade
      no-stacking
      no-enforce-focus
      no-close-on-backdrop
      @hidden="closeDialogBeforeLeave()"
      @hide="closeDialogBeforeLeave()"
      @close="closeDialogBeforeLeave()"
      @cancel="closeDialogBeforeLeave()"
    >
      <div class="col-12 h-100">
        <div class="col-10 mb-4 d-flex input-material mx-auto">
          <input
            placeholder="Employee Name"
            type="text"
            v-model="employeeDetails.employee_name"
            name="employee_name"
            id="employee_name"
            class="form-control"
            @click="onClickInputHandler('name')"
          />
          <label>{{ "Employee Name" }}</label>
          <VkeyboardFloat
            :ID="'employee_name'"
            :onClickFun="
              () => {
                keyboardObj['showENameKeyboard'] =
                  !keyboardObj['showENameKeyboard'];
              }
            "
          />
          <Vkeyboard
            :inputName="'employee_name'"
            :showOrHide="keyboardObj['showENameKeyboard']"
            :initialValue="employeeDetails.employee_name"
            @onChangeEvent="() => {}"
            @onKeyEnter="onSaveDetails"
            @changeKeyboardInput="employeeDetails.employee_name = $event"
            @onClickClose="
              () => {
                keyboardObj['showENameKeyboard'] = false;
              }
            "
          />
        </div>

        <div class="col-10 mb-4 d-flex input-material mx-auto">
          <input
            placeholder="Employee Code"
            type="text"
            v-model="employeeDetails.employee_code"
            name="employee_code"
            id="employee_code"
            class="form-control"
            @click="onClickInputHandler('code')"
          />
          <label>{{ "Employee Code" }}</label>
          <VkeyboardFloat
            :ID="'employee_code'"
            :onClickFun="
              () => {
                keyboardObj['showECodeKeyboard'] =
                  !keyboardObj['showECodeKeyboard'];
              }
            "
          />
          <Vkeyboard
            :inputName="'employee_code'"
            :showOrHide="keyboardObj['showECodeKeyboard']"
            :initialValue="employeeDetails.employee_code"
            @onChangeEvent="() => {}"
            @onKeyEnter="onSaveDetails"
            @changeKeyboardInput="employeeDetails.employee_code = $event"
            @onClickClose="
              () => {
                keyboardObj['showECodeKeyboard'] = false;
              }
            "
          />
        </div>

        <div class="text-center mx-auto">
          <div class>
            <button
              @click="onCancelEmployeeDetails()"
              class="btn btn-sm btn-outline-primary text-dark mr-1"
            >
              Cancel
            </button>
            <button
              v-on:click="onSaveDetails()"
              class="btn btn-sm btn-primary text-white ml-1"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";

export default {
  props: {
    refId: {
      type: String,
      default: "addEmployeeDetails",
    },
    moduleName: {
      type: String,
      default: "default",
    },
    onCheckEmployeeDetails: {
      type: Function,
      default: () => console.log("default function"),
    },
  },
  components: {
    VkeyboardFloat,
    Vkeyboard,
  },
  data() {
    return {
      employeeDetails: {
        employee_name: "",
        employee_code: "",
      },
      keyboardObj: {
        showENameKeyboard: false,
        showECodeKeyboard: false,
      },
      submitted: false,
    };
  },
  computed: {
    ...mapGetters(["getEmployeeDetails"]),
  },
  mounted() {
    // Object.keys(this.employeeDetails).map((key) => {
    //   if (this.getEmployeeDetails[key]) {
    //     this.employeeDetails[key] = this.getEmployeeDetails[key];
    //   } else {
    //     this.employeeDetails[key] = ""
    //   }
    // });
  },
  beforeMount() {
    console.log("this.getEmployeeDetails[key]", this.getEmployeeDetails);
  },
  methods: {
    ...mapActions(["onSetEmployeeDetails", "onResetEmployeeDetails"]),
    closeDialogBeforeLeave() {
      this.employeeDetails = {
        employee_name: "",
        employee_code: "",
      };
    },
    onClickInputHandler(event) {
      if (this.keyboardObj["showENameKeyboard"] && event == "code") {
        this.keyboardObj["showENameKeyboard"] = false;
        this.keyboardObj["showECodeKeyboard"] = true;
      } else if (this.keyboardObj["showENameKeyboard"] && event == "name") {
        this.keyboardObj["showENameKeyboard"] = false;
        this.keyboardObj["showECodeKeyboard"] = false;
      } else if (this.keyboardObj["showECodeKeyboard"] && event == "name") {
        this.keyboardObj["showENameKeyboard"] = true;
        this.keyboardObj["showECodeKeyboard"] = false;
      } else if (this.keyboardObj["showECodeKeyboard"] && event == "code") {
        this.keyboardObj["showENameKeyboard"] = false;
        this.keyboardObj["showECodeKeyboard"] = false;
      }
    },
    onCancelEmployeeDetails() {
      this.onResetEmployeeDetails();
      this.$bvModal.hide(this.refId);
    },
    onSaveDetails() {
      if (!this.employeeDetails["employee_name"]) {
        this.$toasted.show("Please Enter Employee Name");
      } else {
        this.onSetEmployeeDetails(this.employeeDetails);
        this.onCheckEmployeeDetails({
          name: this.moduleName,
          valid: true,
        });
      }
    },
  },
};
</script>
<style>
.disbled-section {
  cursor: not-allowed;
  opacity: 0.4;
}

.employeeDetails__title_class {
  font-size: 12px !important;
}

.employeeDetails__header_class {
  padding: 0.4rem 1rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/AddEmployeeDiscountDetails.vue